import { ColumnDef } from '@tanstack/react-table';
import { Pencil, Trash2 } from 'lucide-react';
import { DataTableColumnHeader } from '@/components/core';
import { Button } from '@/components/ui-kit/button';
import { SkillSubCategory } from '../../types/skill-sub-category.types';

interface CreateSkillSubCategoryTableColumnsProps {
  t: (key: string) => string;
  onEdit: (skillSubCategory: SkillSubCategory) => void;
  onDelete: (skillSubCategory: SkillSubCategory) => void;
  canUpdate?: boolean;
  canDelete?: boolean;
}

export const createSkillSubCategoryTableColumns = ({
  t,
  onEdit,
  onDelete,
  canUpdate = true,
  canDelete = true,
}: CreateSkillSubCategoryTableColumnsProps): ColumnDef<SkillSubCategory>[] => [
  {
    id: 'Title',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('TITLE')} />,
    accessorFn: (row) => row.Title ?? '',
    cell: ({ row }) => <span className="truncate font-medium">{row.original.Title}</span>,
  },
  ...(canUpdate || canDelete
    ? [
        {
          id: 'actions',
          // Card: top right, as the old portal's card header.
          meta: { mobile: 'badge' as const },
          header: () => <span className="text-xs font-medium">{t('ACTION')}</span>,
          enableSorting: false,
          enableHiding: false,
          cell: ({ row }: { row: { original: SkillSubCategory } }) => (
            <div className="flex items-center gap-1">
              {canUpdate && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onEdit(row.original)}
                  aria-label={t('EDIT')}
                >
                  <Pencil className="size-4" />
                </Button>
              )}
              {canDelete && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onDelete(row.original)}
                  aria-label={t('DELETE')}
                >
                  <Trash2 className="size-4" />
                </Button>
              )}
            </div>
          ),
        },
      ]
    : []),
];
